module.exports = __webpack_public_path__ + "img/david.492cb0e1.svg";